import { PublicCatalogService } from '../../../catalog-services/public-catalog-service';
export class PublicChannel extends PublicCatalogService {
    /**
     * Returns a list of purchases made by currently active user
     * @param {string} channelId
     * @param {string} instance
     * @returns {Promise<HttpResponse<MemberInfoResponse>>}
     */
    getMemberInfo(channelId, instance, requestConfig) {
        return this.get(`/public/lists/${channelId}/member/info?instance=${instance}`, requestConfig);
    }
    getVideoPreviewUrls(channelId, instance, requestConfig) {
        const params = { instance };
        return this.get(`/public/lists/play/${channelId}`, {
            params,
            ...requestConfig,
        });
    }
    /**
     * Returns channel response (similar to PrivateChannel entity)
     * @param channelId
     * @param requestConfig
     * @return Promise<HttpResponse<PublicChannelItem>>
     */
    getInfo(channelId, requestConfig) {
        return this.get(`/public/lists/${channelId}/info`, requestConfig);
    }
}
//# sourceMappingURL=channel.js.map